import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material";

export default function HeadbandRadio({ currentHeadlinesList, currentSong , fontSizeW = "21px", fontSizeM = "18px" }) {
    const theme = useTheme();
    const [headlinesList, setHeadlinesList] = useState(currentHeadlinesList || []);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleMarqueeOnCycleComplete = () => {
        setCurrentIndex((currentIndex + 1) % headlinesList.length);
    };

    useEffect(() => {
        if (currentHeadlinesList.length > 0 && headlinesList.length === 0) {
            setHeadlinesList(currentHeadlinesList);
        }

        if (headlinesList[currentIndex]?.time > 0) {
            setTimeout(() => {
                setCurrentIndex((currentIndex + 1) % headlinesList.length);
            }, headlinesList[currentIndex]?.time * 1000);
        }
    }, [currentIndex, headlinesList, currentHeadlinesList]);

    useEffect(() => {
        if (currentHeadlinesList?.length > 0) {
            setHeadlinesList(currentHeadlinesList);
        }
    }, [currentSong]);
    useEffect(() => {}, [headlinesList, currentIndex]);
    return (
        <Box sx={{ width: "100%", color: theme.noticeCard.text }}>
            {headlinesList[currentIndex]?.time === 0 && (
                <Marquee
                    delay={1}
                    speed={30}
                    onCycleComplete={handleMarqueeOnCycleComplete}
                    gradient={false}
                >
                    <Typography sx={{ fontSize: fontSizeW }}>
                        {headlinesList[currentIndex]?.text}
                    </Typography>
                </Marquee>
            )}
            {headlinesList[currentIndex]?.time > 0 && (
                <Typography sx={{ fontSize: fontSizeM }}>{headlinesList[currentIndex]?.text}</Typography>
            )}
        </Box>
    );
}
